// extracted by mini-css-extract-plugin
export default {"MainCard":"MainCard_MainCard__Hw6hw","content":"MainCard_content__EHCLy"};